export const COLORS = [
  "#027E00",
  "#C64F00",
  "#FFF700",
  "#aaffc3",
  "#F13EDE",
  "#f032e6",
  "#4A235A",
  "#0E6655",
  "#17202A",
  "#800000"
];

export const initialFen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
export const emptyFen = "8/8/8/8/8/8/8/8 w KQkq - 0 1";

export const isObjectsEqual = (value, other) => {
  const type = Object.prototype.toString.call(value);
  if (type !== Object.prototype.toString.call(other)) return false;
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;
  const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
  const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false;
  const compare = (item1, item2) => {
    const itemType = Object.prototype.toString.call(item1);
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isObjectsEqual(item1, item2)) return false;
    }
    else {
      if (itemType !== Object.prototype.toString.call(item2)) return false;
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false;
      } else if (item1 !== item2) return false;
    }
    return true;
  };
  if (type === '[object Array]') {
    for (let i = 0; i < valueLen; i += 1) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    const keys = Object.keys(value);
    for (let k = 0; k < keys.length; k += 1) {
      const key = keys[k];
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  }
  return true;
};


const ENGINES = ['asmfish', 'stockfish10', 'sugar', 'lc0', 'berserk', 'caissa', 'crystal', 'patricia', 'viridithas', 'koivisto', 'rubichess', 'shashchess', 'komodo'];
export { ENGINES as default };

export const ENGINES_NAMES = {
  'asmfish': 'AsmFish',
  'stockfish10': 'Stockfish',
  'sugar': 'Sugar AI',
  'lc0': 'LCZero',
  'berserk': 'Berserk',
  'caissa': 'Caissa',
  'crystal': 'Crystal',
  'patricia': 'Patricia',
  'viridithas': 'Viridithas',
  'koivisto': 'Koivisto',
  'rubichess': 'RubiChess',
  'shashchess': 'ShashChess',
  'komodo': 'Komodo'
}

export const PRODUCT_IDS = {
  'Trial': 1,
  'Free': 14,
  'Amateur-month': 15,
  'Amateur-year': 16,
  'Master-month': 17,
  'One-time-payment': 21,
  'Master-year': 24,
  'GM-year': 25,
  'GM-month': 45,
  'Amateur-combo-month': 26,
  'Amateur-combo-year': 27,
  'Master-combo1-month': 28,
  'Master-combo1-year': 29,
  'Master-combo2-month': 30,
  'Master-combo2-year': 31,
  'Super-GM': 32,
  'Unlimited-300': 33,
  'Unlimited-130': 34,
  'Unlimited-700': 35,
  'Unlimited-130-LC0': 36,
  'Unlimited-300-LC0': 37,
  'Unlimited-700-LC0': 38,
  'Unlimited-1000': 39,
  'Unlimited-1500': 40,
  'Unlimited-1000-LC0': 41,
  'Unlimited-1500-LC0': 42,
  'Unlimited-2000': 43,
  'Unlimited-2000-LC0': 44
}

export function getEngineIndex(engineCore) {
  const servers = {
    "asmfish": [8, 16, 32, 128],
    "sugar": [8, 16, 32, 128],
    "berserk": [8, 16, 32, 128],
    "caissa": [8, 16, 32, 128],
    "crystal": [8, 16, 32, 128],
    "patricia": [8, 16, 32, 128],
    "viridithas": [8, 16, 32, 128],
    "koivisto": [8, 16, 32, 128],
    "rubichess": [8, 16, 32, 128],
    "shashchess": [8, 16, 32, 128],
    "komodo": [129, 130],
    "stockfish10": [8, 16, 32, 128, 160, 352, 512, 768, 1024],
    "lc0": [100, 200, 400]
  }

  for (const key in servers) {
    if (servers[key].includes(engineCore)) {
      return ENGINES.indexOf(key);
    }
  }
  return 0;
}

export function getEnginesListFromAvailableServers(availableServers, orderedServers) {
  const result = {};
  const servers = {
    "asmfish": [8, 16, 32, 128],
    "sugar": [8, 16, 32, 128],
    "berserk": [8, 16, 32, 128],
    "caissa": [8, 16, 32, 128],
    "crystal": [8, 16, 32, 128],
    "patricia": [8, 16, 32, 128],
    "viridithas": [8, 16, 32, 128],
    "koivisto": [8, 16, 32, 128],
    "rubichess": [8, 16, 32, 128],
    "shashchess": [8, 16, 32, 128],
    "komodo": [129, 130],
    "stockfish10": [8, 16, 32, 128, 160, 352, 512, 768, 1024],
    "lc0": [100, 200, 400]
  };
  const orderedEngines = Object.keys(orderedServers);

  ENGINES.forEach(engine => {
    if (orderedEngines.indexOf(engine) !== -1) {
      result[engine] = [orderedServers[engine][0]];
    } else {
      const res = [];
      const index = {};
      const orderedEngineInfo = orderedServers[engine];

      availableServers.forEach(s => {
        if (servers[engine].indexOf(s.cores) !== -1) {
          if (!index[s.cores]) {
            index[s.cores] = true;
            res.push(s);
          }
        }
      });

      res.sort((a, b) => {
        return parseInt(a.cores) - parseInt(b.cores)
      });

      if (res.length) {
        result[engine] = res;
      }
    }
  })
  return result;
}

export function uniqueServers(engineIndex, availableServers) {
  const res = [];
  const index = {};
  const servers = {
    "asmfish": [8, 16, 32, 128],
    "sugar": [8, 16, 32, 128],
    "berserk": [8, 16, 32, 128],
    "caissa": [8, 16, 32, 128],
    "crystal": [8, 16, 32, 128],
    "patricia": [8, 16, 32, 128],
    "viridithas": [8, 16, 32, 128],
    "koivisto": [8, 16, 32, 128],
    "rubichess": [8, 16, 32, 128],
    "shashchess": [8, 16, 32, 128],
    "komodo": [129, 130],
    "stockfish10": [8, 16, 32, 128, 160, 352, 512, 768, 1024],
    "lc0": [100, 200, 400]
  };

  availableServers.forEach(s => {
    const engine = ENGINES[engineIndex];
    if (servers[engine].indexOf(s.cores) !== -1) {
      if (!index[s.cores]) {
        index[s.cores] = true;
        res.push(s);
      }
    }
  });

  res.sort((a, b) => {
    return a.cores - b.cores;
  });

  return res;
}

export function coreToKNode(engineIndex, cores, selectedEngine) {
  const engine = engineIndex !== null ? ENGINES[engineIndex] : selectedEngine;
  const table = {
    sugar: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    stockfish10: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      },
      160: {
        average: '300,000',
        caption: '300 MN/s'
      },
      352: {
        average: '700,000',
        caption: '700 MN/s'
      },
      512: {
        average: '1,000,000',
        caption: '1 BN/s'
      },
      768: {
        average: '1,500,000',
        caption: '1.5 BN/s'
      },
      1024: {
        average: '2,000,000',
        caption: '2 BN/s'
      }
    },
    asmfish: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    berserk: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    caissa: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    crystal: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    patricia: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    viridithas: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    koivisto: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    rubichess: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    shashchess: {
      8: {
        average: '1,000',
        caption: '1 MN/s'
      },
      16: {
        average: '10,000',
        caption: '10 MN/s'
      },
      32: {
        average: '100,000',
        caption: '25-100 MN/s'
      },
      128: {
        average: '130,000',
        caption: '130 MN/s'
      }
    },
    komodo: {
      129: {
        average: 'Komodo',
        caption: 'Komodo'
      },
      130: {
        average: 'Torch',
        caption: 'Torch'
      }
    },
    lc0: {
      100: {
        average: 'Standard',
        caption: 'Standard'
      },
      200: {
        average: 'Advanced',
        caption: 'Advanced'
      },
      400: {
        average: 'Ultra',
        caption: 'Ultra'
      }
    }
  };

  if (!table[engine] || !(cores in table[engine])) {
    return {
      average: '123,456',
      caption: '123 MN/s'
    };
  }

  return table[engine][cores];
}

export function getUrlParameter(name) {
  const cleared = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${cleared}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null
    ? null
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function setCookie(cname, cvalue) {
  document.cookie = cname + "=" + cvalue + ";";
}

export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookie(cname) {
  document.cookie = `${cname}=; path=/;`;
}

export function countSubscriptionPriceDiscount(price, discount) {
  return price * (1 - discount / 100);
}


export function correctFen(fen) {
  return fen.replace(/.$/, "1")
}

export function checkEmptyObject(obj) {
  return obj && Object.keys(obj).length > 0 && obj.constructor === Object
}

export function formatDate(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  let year = d.getFullYear();
  let hour = d.getHours();
  let minute = d.getMinutes();

  if (month.length < 2)
    month = `0${month}`;
  if (day.length < 2)
    day = `0${day}`;
  if (minute <= 9)
    minute = `0${minute}`;
  if (hour <= 9)
    hour = `0${hour}`;

  return `${[year, month, day].join('-')} ${[hour, minute].join(':')}`;
}

export function setPlanPricing(plan) {
  const priceList = {
    Starter: '4.99',
    Pro: '24.99',
    Master: '99.99',
    GM: '499.99'
  }
  return priceList[plan];
}

export function showEngineInfo(type) {
  switch (type) {
    case 'Temp':
      return 'The server will connect in 2-3 minutes. Meanwhile, you can analyze on 10MN/s server for Free.';
    case 'Delayed':
      return 'Sorry, additional 2-3 minutes are needed for server allocation.';
    case 'Try Later':
      return 'Sorry, but this time your order could not be completed. Please try later.';
    default:
      return 'Free analysis on a server of up to 100,000 kN/s speed';
  }
}

export function showAnalizeButton(user, core, pricePerMinute) {
  const { subscription, balance } = user;

  if (core === 8) {
    return true;
  }

  if (core === 16) {
    if (subscription) {
      if ((new Date(subscription.valid_till) >= Date.now())) {
        return true
      } else {
        return false
      }
    }
    else {
      return false;
    }
  }

  if (core === 32) {
    if (
      !subscription ||
      parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-month'] ||
      parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-year'] ||
      parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-combo-month'] ||
      parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-combo-year']
    ) {
      return false;
    } else if (subscription) {
      if (new Date(subscription.valid_till) >= Date.now()) {
        return true;
      } else {
        return false;
      }
    }
  }

  if (core > 32) {
    if (balance > 0) {
      return true;
    }
    if (core === 100) {
      if (
        subscription &&
        [
          PRODUCT_IDS['GM-year'],
          PRODUCT_IDS['GM-month'],
          PRODUCT_IDS['Unlimited-130-LC0'],
          PRODUCT_IDS['Unlimited-300-LC0'],
          PRODUCT_IDS['Unlimited-700-LC0'],
          PRODUCT_IDS['Unlimited-1000-LC0'],
          PRODUCT_IDS['Unlimited-1500-LC0'],
          PRODUCT_IDS['Unlimited-2000-LC0']
        ].includes(parseInt(subscription.product_id))
      ) {
        if (new Date(subscription.valid_till) >= Date.now()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    if (core === 128) {
      if (subscription && (parseInt(subscription.product_id) === 34 || parseInt(subscription.product_id) === 36)) {
        if (new Date(subscription.valid_till) >= Date.now()) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (core === 160) {
      if (subscription && (parseInt(subscription.product_id) === 33 || parseInt(subscription.product_id) === 37)) {
        if (new Date(subscription.valid_till) >= Date.now()) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (core === 352) {
      if (subscription && (parseInt(subscription.product_id) === 35 || parseInt(subscription.product_id) === 38)) {
        if (new Date(subscription.valid_till) >= Date.now()) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (core === 512) {
      if (subscription && (parseInt(subscription.product_id) === 39 || parseInt(subscription.product_id) === 41)) {
        if (new Date(subscription.valid_till) >= Date.now()) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (core === 768) {
      if (subscription && (parseInt(subscription.product_id) === 40 || parseInt(subscription.product_id) === 42)) {
        if (new Date(subscription.valid_till) >= Date.now()) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }
}
